<template>
  <form @submit.prevent="submit">
    <div class="form-group">
      <label>Nama Kategori <span class="text-danger">*</span></label>
      <input
        v-model="form.name"
        class="form-control"
        :class="{ 'is-invalid': errors.name }"
      />
      <div v-if="errors.name" class="invalid-feedback">
        {{ errors.name }}
      </div>
    </div>

    <div class="text-end mt-4">
      <button
        type="button"
        class="btn btn-secondary me-2"
        @click="$emit('cancel')"
        :disabled="loading"
      >
        Batal
      </button>

      <button class="btn btn-primary" :disabled="loading">
        <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
        Simpan
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  props: { id: Number },

  data() {
    return {
      loading: false,
      errors: {},
      form: {
        name: "",
        is_active: true, // ADD default
      },
    };
  },

  mounted() {
    if (this.id) this.fetchDetail();
  },

  methods: {
    getAuthHeader() {
      return { Authorization: "Bearer " + localStorage.access_token };
    },

    fetchDetail() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            `master/kms/video/kategori/${this.id}`,
          { headers: this.getAuthHeader() }
        )
        .then(res => {
          this.form.name = res.data.data.name;
          this.form.is_active = res.data.data.is_active;
        });
    },

    submit() {
      this.loading = true;
      this.errors = {};

      const req = this.id
        ? axios.put(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              `master/kms/video/kategori/${this.id}`,
            this.form,
            { headers: this.getAuthHeader() }
          )
        : axios.post(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kms/video/kategori",
            this.form,
            { headers: this.getAuthHeader() }
          );

      req
        .then(() => this.$emit("success"))
        .catch(err => {
          if (err.response?.status === 422) {
            Object.entries(err.response.data.errors).forEach(
              ([k, v]) => (this.errors[k] = v[0])
            );
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
